module.exports = __webpack_public_path__ + "static/media/obdo.4771818d.png";